import React from 'react';
import { Controller, useFormContext, FieldValues, Path } from 'react-hook-form';
import { Checkbox, FormControlLabel, CheckboxProps } from '@mui/material';

type Props<T extends FieldValues> = {
  name: Path<T>;
  label: string;
  disabled?: boolean;
  sx?: CheckboxProps['sx'];
};

/**
 * A checkbox component that uses react-hook-form's Controller
 * to directly bind to a specific path in the form schema
 */
function PathControlledCheckbox<T extends FieldValues>({ name, label, disabled = false, sx }: Props<T>) {
  const { control } = useFormContext<T>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <FormControlLabel
          control={
            <Checkbox checked={!!value} onChange={disabled ? () => {} : (e) => onChange(e.target.checked)} sx={sx} />
          }
          label={label}
        />
      )}
    />
  );
}

export default PathControlledCheckbox;
